import {State, Module} from 'app/decorators';
import BaseRoute from 'app/routing';
import CompaniesComponent from 'app/directives/companies.component';
import UnitsPicker from 'app/directives/blnd.units.picker';
import MaxRateComponent from 'app/admin/components/max.rates.table';
import ActiveFilterComponent from 'app/admin/components/active.filter';
import Activity from 'app/directives/activity';

import {ProductsCtrl, ProductCtrl, LogCtrl} from './ctrls';

import mainTpl from './templates/main.html';
import detailTpl from './templates/details.html';
import logsTpl from './templates/logs.html';

import tableSectionTpl from './templates/table.section.html';
import detailSectionTpl from './templates/detail.section.html';


@Module({
    name: 'app.admin.products',
    modules: [
        BaseRoute,
        UnitsPicker,
        CompaniesComponent,
        MaxRateComponent,
        ActiveFilterComponent,

        Activity,
    ],
})
@State({
    name: 'r.in.top.admin.products',
    url: '/products',
    template: mainTpl,
    abstract: '.list',
    ncyBreadcrumb: {
        skip: true,
    },
    data: {
        permissions: {
            only: [
                'main.view_product',
            ]
        }
    }
})
@State({
    name: 'r.in.top.admin.products.list',
    url: '?search',
    views: {
        tableView: {
            template: tableSectionTpl,
            controller: ProductsCtrl,
        },
        detailsView: {
            template: detailSectionTpl,
            controller: ProductCtrl,
        },
    },
    resolve: {
        $object: function () {
            return null;
        },
        $productRate: function () {
            return null;
        }
    },
    ncyBreadcrumb: {
        label: 'Products',
    },
})
@State({
    name: 'r.in.top.admin.products.list.product',
    url: '/{objectId:int}',
    ncyBreadcrumb: {
        skip: true,
    },
    template: '<ui-view/>',
    resolve: {
        $object: function($stateParams, ProductStore) {
            return ProductStore.get($stateParams.objectId);
        },
        $productRate: function($object) {
            return $object.one('rate').getList();
        }
    },
    abstract: '.detail',
})
@State({
    name: 'r.in.top.admin.products.list.product.detail',
    url: '/details',
    controller: ProductCtrl,
    template: detailTpl,
    as: 'vmc',
    ncyBreadcrumb: {
        label: '{{ vmc.object.title }}',LogCtrl
    },
})
@State({
    name: 'r.in.top.admin.products.list.product.logs',
    url: '/log',
    controller: LogCtrl,
    template: logsTpl,
    ncyBreadcrumb: {
        label: 'Logs',
    },
})
export default class States { }



// WEBPACK FOOTER //
// ./src/app/admin/product/routing.js